import { createApi } from "@reduxjs/toolkit/query/react";
import { HttpMethod, RESTAURANT } from "../../data/constants";
import { Restaurant } from "../../data/interfaces";
import { createBaseQuery } from "../helpers/baseQueryHelper";

const restaurantApi = createApi({
  reducerPath: RESTAURANT.reducerPath,
  baseQuery: createBaseQuery(RESTAURANT.baseUrl),
  tagTypes: RESTAURANT.tagTypes,
  endpoints(builder) {
    return {
      updateStatus: builder.mutation<Restaurant, { isActive: boolean }>({
        query: (params) => ({
          url: "/status",
          method: HttpMethod.PATCH,
          params,
        }),
      }),
    };
  },
});

export const { useUpdateStatusMutation } = restaurantApi;

export { restaurantApi };
